import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from './select-next';
import {PossibleMilitaryStatuses} from "./possible-military-statuses";

const MilitaryStatus = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseSelect
      label="Military Status"
      name="militaryStatus"
      options={PossibleMilitaryStatuses}
      transparent
      disabledStateValue={{ value: '', label: '' }}
      data-cv-test="militaryStatus"
      {...props}
      data-cv-test-override={dataCvTest || 'militaryStatus'}
      canContainEmptyDefaultValue
    />
  );
};

MilitaryStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

MilitaryStatus.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': 'militaryStatus'
};

export default MilitaryStatus;
